<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
        video-url="https://share.synthesia.io/embeds/videos/cc2a2038-a3f9-45d6-8f5c-c86703a71c50"
        video-titulo="Expedientes"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaExpedientes',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#1976D2'
        }
    },
    data() {
        return {
            faqs: [
                {
                    id: 1,
                    pregunta: '¿Qué filtros puedo usar en Expedientes?',
                    respuesta: `
                        <p>Puedes filtrar por:</p>
                        <ul>
                            <li>Código</li>
                            <li>Código Agencia</li>
                            <li>Fecha inicio</li>
                            <li>Estado</li>
                            <li>Cliente</li>
                            <li>Solicitud</li>
                            <li>Peregrinos</li>
                            <li>Habitaciones</li>
                        </ul>
                    `,
                    respuestaTexto: 'Puedes filtrar por Código, Código Agencia, Fecha inicio, Estado, Cliente, Solicitud, Peregrinos y Habitaciones.'
                },
                {
                    id: 2,
                    pregunta: '¿Qué significa el estado de una reserva?',
                    respuesta: `
                        <p>El estado indica su etapa operativa, por ejemplo <strong>SOLICITADA</strong>, <strong>PRESUPUESTADA</strong> o <strong>CONFIRMADA</strong>.</p>
                        <p>Además se muestra con su color correspondiente en la tabla y en el detalle.</p>
                    `,
                    respuestaTexto: 'El estado indica su etapa operativa, por ejemplo SOLICITADA, PRESUPUESTADA o CONFIRMADA. Además se muestra con su color correspondiente en la tabla y en el detalle.'
                },
                {
                    id: 3,
                    pregunta: '¿Por qué no veo algunas reservas?',
                    respuesta: `
                        <p>El listado aplica reglas por origen del usuario logueado.</p>
                        <p>Si eres agencia, solo verás reservas de tu propio origen.</p>
                    `,
                    respuestaTexto: 'El listado aplica reglas por origen del usuario logueado. Si eres agencia, solo verás reservas de tu propio origen.'
                },
                {
                    id: 4,
                    pregunta: '¿Cómo se aplican los filtros de la tabla?',
                    respuesta: `
                        <p>Cada columna dispone de su propio filtro.</p>
                        <p>Al pulsar <strong>Enter</strong> o limpiar el campo con el icono <strong>clear</strong>, el listado vuelve a consultar el endpoint con los parámetros actualizados.</p>
                    `,
                    respuestaTexto: 'Cada columna dispone de su propio filtro. Al pulsar Enter o limpiar el campo con el icono clear, el listado vuelve a consultar el endpoint con los parámetros actualizados.'
                },
                {
                    id: 5,
                    pregunta: '¿Cómo funciona la ordenación de columnas?',
                    respuesta: `
                        <p>Puedes ordenar por:</p>
                        <ul>
                            <li>Código</li>
                            <li>Ref. agencia</li>
                            <li>Fechas camino</li>
                            <li>Estado</li>
                            <li>Cliente</li>
                            <li>Solicitud</li>
                            <li>Peregrinos</li>
                            <li>Habitaciones</li>
                        </ul>
                        <p>La ordenación se hace contra el servidor.</p>
                    `,
                    respuestaTexto: 'Puedes ordenar por Código, Ref. agencia, Fechas camino, Estado, Cliente, Solicitud, Peregrinos y Habitaciones. La ordenación se hace contra el servidor.'
                },
                {
                    id: 6,
                    pregunta: '¿Qué hago si abro un detalle y quiero volver al listado?',
                    respuesta: `
                        <p>Cierra el diálogo del detalle para seguir trabajando en la tabla.</p>
                        <p>Los filtros, la paginación y la ordenación del listado se conservan.</p>
                    `,
                    respuestaTexto: 'Cierra el diálogo del detalle para seguir trabajando en la tabla. Los filtros, la paginación y la ordenación del listado se conservan.'
                }
            ]
        };
    }
};
</script>
